
import { Component, Vue } from "vue-property-decorator";
import { readUserProfile } from "@/store/main/getters";
@Component
class ResidentStatus extends Vue {
  public lastDayOfMonth: Date = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

  // public checkResidentStatus = 'RESIDENT_LIMITED'; // for test locally - userProfile?.resident_status?.status
  // public checkResidentMonthsCount = 0  // for test locally - userProfile?.resident_status?.limited_months_count
  
  get userProfile() {
    return readUserProfile(this.$store);
  }
}
export default ResidentStatus;
